import React from "react"
import { ProgressBar } from "@blueprintjs/core"
import { useSelector } from "react-redux"
import { useSelectedOrdersArray } from "store/dispatch.redux"

const VehicleCapacityBar = () => {
  const vehicleCapacity = useSelector(
    (state: any) => state.dispatch.vehicle?.vehicleType?.capacity
  )
  const orders = useSelectedOrdersArray()
  const totalWeight = orders?.reduce?.((p, o) => p + o?.totalWeight, 0)

  const filled =
    !vehicleCapacity || !totalWeight
      ? 0
      : totalWeight / vehicleCapacity > 1
      ? 1
      : totalWeight / vehicleCapacity ?? 0

  return (
    <ProgressBar
      animate={false}
      intent={filled < 0.25 ? "danger" : filled < 0.5 ? "warning" : "success"}
      value={filled}
    />
  )
}

export default VehicleCapacityBar
